export const formatPracticeUrlWithHttp = (office) => {
    const url = office?.practice?.practiceUrl;
    if (url && url.trim() !== "") {
        return url.startsWith("http") || url.startsWith("https") ? url : `https://${url}`;
    }
    return "";
};